// extracted by mini-css-extract-plugin
export default {"radio":"MGInputRadioButton_radio__kYQ0o","input":"MGInputRadioButton_input__UZ-Ii","visual":"MGInputRadioButton_visual__Mh5PO","inner":"MGInputRadioButton_inner__swkBm"};